export default __webpack_public_path__ + "assets/images/10ec40e69b3822508e0971f02a9bc1ac.png";